import { useWatch } from "react-hook-form";
import { AliasInputField } from "./shared/AliasInputField";
import { AmountField } from "./shared/AmountField";
import { NextReviewButton } from "./shared/NextReviewButton";
import { useAliasVerification } from "../shared/useAliasVerification";

export function AliasAmountFields({
  control,
  onNext,
  isLoading,
  walletBalance,
  isBalanceError,
  validators,
}) {
  const { handleAliasChange, handleAliasBlur, isVerifying, isVerified } = useAliasVerification();
  const amount = useWatch({ control, name: "amount" });
  const canProceed = isVerified && !!amount;

  const getTooltipLabel = () => {
    if (isVerified && amount) return undefined;
    if (isVerified) return "Enter an amount to continue";
    return "Verify your details to continue";
  };
  const tooltipLabel = getTooltipLabel();

  return (
    <div className="space-y-4">
      <AliasInputField
        control={control}
        aliasValidator={validators.alias}
        handleAliasChange={handleAliasChange}
        handleAliasBlur={handleAliasBlur}
        isVerifying={isVerifying}
        isLoading={isLoading}
      />

      <AmountField
        control={control}
        amountValidator={validators.amount}
        walletBalance={walletBalance}
        isBalanceError={isBalanceError}
        isLoading={isLoading}
      />

      <NextReviewButton
        onNext={onNext}
        isLoading={isLoading}
        canProceed={canProceed}
        tooltipLabel={tooltipLabel}
      />
    </div>
  );
}
